import styled, { css } from 'styled-components';

import Button from '@components/Button';

export const ResponsiveSearchSubmitButtonWrapper = styled.div<{
  isTravelPlanning?: boolean;
}>`
  ${({ isTravelPlanning = false }) =>
    isTravelPlanning &&
    css`
      grid-row: 3/4;
      width: 100%;
      padding: 10px 15px;
      display: flex;
      align-items: center;
      position: absolute;
      bottom: 0px;
      right: 0px;
      background-color: ${({ theme }) => theme.palette.white};
      z-index: 10;
      border-top: 1px solid ${({ theme }) => theme.palette.grey300};
    `}
`;

export const ResponsiveSearchDrawerButton = styled(Button)`
  width: 100%;
  display: block;
`;
